import styled from 'styled-components/macro';

export const TableViewWrapper = styled('div')`
  .block__wrapper {
    table {
      border: 1px solid #eee;
    }
  }
  .block__hover {
    margin-top: 10px !important;
    .block__content {
      line-height: normal;
    }
    .block__wrapper {
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
    }
  }
  .block__hover--readonly .block__wrapper {
    border: solid 1px transparent;
    box-shadow: none;
    .block__content:before,
    .block__content:after {
      border-top: none;
      border-bottom: none;
    }
    .table-manager-block {
      display: flex;
    }
  }

  .table-manager-modal {
    z-index: 2700;
    position: fixed;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    top: 90px;
    bottom: 0;
  }
  .table-manager-modal .bs-modal__body {
    padding: 0 !important;
    display: flex;
    height: 100%;
  }
  .table-manager-modal .bs-modal__footer {
    display: flex;
    justify-content: flex-end;
  }
  .table-manager-modal__form {
    background-color: #f5f6f9;
    border-right: 1px solid #eee;
    box-sizing: border-box;
    padding: 1rem 1.5rem;
  }
  .table-manager-modal__editable-table {
    background-color: #ededed;
    flex-grow: 1;
    position: relative;
    overflow: auto;
    width: 100%;
    height: 100%;
  }
  .table-manager-modal__table-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    white-space: nowrap;
  }
  .table-manager-modal__table-wrapper:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -0.25em;
    /* Adjusts for spacing */
  }
  .table-manager-modal table {
    display: inline-block;
    vertical-align: middle;
    border-collapse: separate;
    padding: 2rem;
    width: auto;
    border-spacing: 0;
  }
  .table-manager-modal .table-row {
    background-color: #fff;
  }
  .table-manager-modal .table-cell {
    background-color: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    height: 38px;
    line-height: 20px;
    min-height: 32px;
    text-align: start;
    white-space: pre-line;
    box-sizing: border-box;
    min-width: 128px;
    cursor: text;
    letter-spacing: -0.01562rem;
  }
  .table-manager-modal .table-cell:last-child {
    border-right: 0;
  }
  .table-manager-modal .table-cell input {
    border: 0px;
    font: inherit;
    line-height: inherit;
    width: 100%;
    height: 100%;
    min-height: 38px;
    padding: 0;
  }
  .table-manager-modal .table-cell input:focus {
    outline: none;
  }
  .table-manager-modal .table-cell.selected-cell {
    border: 3px solid #4990e2 !important;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .table-manager-modal .table-cell-content {
    padding: 8px 10px;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-checkbox {
    display: inline-block;
    margin-right: 14px;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-checkbox:last-child {
    margin-right: 0;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-checkbox input {
    margin-left: -2px;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-checkbox input:before {
    top: 6px;
    height: 12px;
    width: 12px;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-checkbox input:after {
    top: 7px;
    height: 8px;
    left: 5px;
    width: 4px;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-checkbox .header-style-icon {
    vertical-align: middle;
    margin-top: 2px;
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-button {
    padding: 0;
  }
  .bs-ui-form-control {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    input:not([type='checkbox']) {
      border-radius: 3px;
      padding: 6px 10px;
      -webkit-appearance: none;
      border: 1px solid #ccc;
    }
  }
  .table-manager-modal .bs-ui-form-control .bs-ui-button.btn-remove,
  .table-manager-modal .bs-ui-form-control .bs-ui-button.btn-add,
  .save {
    overflow: hidden;
    vertical-align: middle;
    text-align: center;
    text-decoration: none;
    text-overflow: ellipsis;
    transition: border-color 0.25s ease-in-out, box-shadow 0.1s ease-in-out,
      background-color 0.25s ease-in-out, color 0.25s ease-in-out;
    border: 1px solid #0268ef;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
    padding: 0px 20px;
    min-width: 20px;
    background-color: #0268ef;
    margin-right: 10px;
  }
  .table-manager-modal .header-style--bottom {
    transform: rotate(180deg);
  }
  .table-manager-modal .header-style--right {
    transform: rotate(90deg);
  }
  .table-manager-modal .header-style--left {
    transform: rotate(270deg);
  }
  .table-manager-modal .header-style__label {
    display: inline-block;
  }
  .table-manager-modal .add-remove-rows .btn-add svg,
  .table-manager-modal .add-remove-columns .btn-add svg,
  .table-manager-modal .add-remove-rows .btn-remove svg,
  .table-manager-modal .add-remove-columns .btn-remove svg {
    height: 16px;
    vertical-align: top;
    width: 16px;
  }
  .table-manager-modal .add-remove-rows .btn-remove svg path,
  .table-manager-modal .add-remove-columns .btn-remove svg path {
    fill: #fff;
  }
  .table-manager-modal .add-remove-rows .btn-add svg path,
  .table-manager-modal .add-remove-columns .btn-add svg path {
    fill: #fff;
  }
  .table-manager-block {
    background-color: #fff;
    padding: 1rem 0;
    overflow: hidden;
  }
  .table-manager-block__wrapper {
    display: inline-block;
  }
  .table-manager-block__title {
    line-height: 32px;
    font-size: 20px;
  }
  .table-manager-block__inner-wrapper {
    display: inline-block;
  }
  .table-manager-block table {
    line-height: 32px;
    border-spacing: 0;
    width: auto;
  }
  .table-manager-block .table-cell {
    background-color: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    height: 38px;
    line-height: 20px;
    min-height: 32px;
    text-align: start;
    white-space: pre-line;
    box-sizing: border-box;
    min-width: 50px;
    border-spacing: 0px;
    padding: 8px 10px;
  }
  .table-manager-block .table-cell:last-child {
    border-right: 0;
  }
  .table-manager-block__source {
    text-align: left;
    font-size: 13px;
    color: #999;
    line-height: 16px;
    padding-bottom: 1rem;
  }
  .highlight-left .table-row:last-child .table-cell:first-child {
    border-bottom: 0;
  }
  .highlight-left .table-row .table-cell:first-child {
    font-weight: bold;
    background-color: #e6e6e6;
    border-right: 0;
    border-bottom: 1px solid #eee;
  }
  .highlight-left .table-row .table-cell:first-child input {
    background-color: #e6e6e6;
  }
  .highlight-left.highlight-top .table-row .table-cell:first-child,
  .highlight-left.highlight-bottom .table-row .table-cell:first-child {
    border-right: 1px solid #eee;
  }
  .highlight-right .table-row:last-child .table-cell:last-child {
    border-bottom: 1px solid #eee;
  }
  .highlight-right .table-row .table-cell:last-child {
    font-weight: bold;
    background-color: #e6e6e6;
    border-bottom: 1px solid #eee;
    border-left: 0;
  }
  .highlight-right .table-row .table-cell:last-child input {
    background-color: #e6e6e6;
  }
  .highlight-right .table-cell {
    border-right: 0;
    border-left: 1px solid #eee;
  }
  .highlight-right .table-cell:first-child {
    border-left: 0;
  }
  .highlight-right.highlight-top .table-row .table-cell:last-child {
    border-left: 1px solid #eee;
  }
  .highlight-right.highlight-top .table-row:first-child .table-cell {
    border-right: 0;
    border-left: 1px solid #eee;
  }
  .highlight-right.highlight-top
    .table-row:first-child
    .table-cell:first-child {
    border-left: 0;
  }
  .highlight-right.highlight-bottom .table-row:last-child .table-cell {
    border-right: 0;
    border-left: 1px solid #eee;
  }
  .highlight-right.highlight-bottom
    .table-row:last-child
    .table-cell:first-child {
    border-left: 0;
  }
  .highlight-top .table-row:first-child {
    font-weight: bold;
    background-color: #e6e6e6;
  }
  .highlight-top .table-row:first-child .table-cell {
    background-color: initial;
    border-bottom: 0;
    border-right: 1px solid #eee;
  }
  .highlight-top .table-row:first-child .table-cell input {
    background-color: #e6e6e6;
  }
  .highlight-top .table-row:first-child .table-cell:last-child {
    border-right: 0;
  }
  .highlight-top.highlight-right .table-row:first-child .table-cell,
  .highlight-top.highlight-left .table-row:first-child .table-cell {
    border-bottom: 1px solid #eee;
  }
  .highlight-bottom .table-row:last-child {
    font-weight: bold;
    background-color: #e6e6e6;
  }
  .highlight-bottom .table-row:last-child input {
    background-color: #e6e6e6;
  }
  .highlight-bottom .table-row:last-child .table-cell {
    border-right: 1px solid #eee;
    background-color: initial;
    border-top: 1px solid #eee;
  }
  .highlight-bottom .table-row:last-child .table-cell:last-child {
    border-right: 0;
  }
  .highlight-bottom .table-row:first-child .table-cell {
    border-top: 0;
  }
  .highlight-bottom .table-cell {
    border-bottom: 0;
    border-top: 1px solid #eee;
  }
  .highlight-bottom.highlight-right
    .table-row:last-child
    .table-cell:last-child {
    border-bottom: 0;
  }
  .highlight-bottom.highlight-right .table-row .table-cell:last-child {
    border-left: 1px solid #eee;
  }
  .head-tooltip-toggle {
    cursor: pointer;
    position: relative;
    margin: 4px;
    vertical-align: middle;
  }
  .head-tooltip-toggle .info-icon {
    color: #666;
    font-size: 14px;
  }
  .head-tooltip-toggle::before {
    background: #616161;
    border-radius: 2px;
    color: rgba(255, 255, 255, 1);
    content: attr(aria-label);
    font-family: 'Roboto', 'Open Sans', 'Helvetica', 'Arial', sans-serif;
    font-size: 12px;
    left: -80px;
    line-height: 16px;
    min-height: 32px;
    opacity: 0;
    padding: 8px;
    position: absolute;
    top: -50px;
    transform: scale(0);
    transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    width: 160px;
  }
  .head-tooltip-toggle:hover::before {
    opacity: 0.9;
    transform: scale(1);
  }
`;
